import React from 'react';

import { SELECT_PLAN_SECTION_ID } from '@/constants';
import { useAppModals } from '@/hooks/useAppModals';
import { useStripeV2Plans } from '@/hooks/useStripeV2Plans';
import { SimplePaymentDescription } from '@/pages/Paywall/components/PaymentDescription/SimplePaymentDescription';
import { SimpleSubscriptionButton } from '@/pages/Paywall/components/SubscriptionButton/SimpleSubscriptionButton';

import {
  SelectPlanListStyles,
  SelectPlanStyles,
  SubscriptionButtonStyles,
} from './SelectPlan.styles';

export const SimpleSelectPlan: React.FC<{
  title: NonNullable<React.ReactNode> | null;
  buttonProps?: {
    onClick?: () => void;
    text?: string;
  };
  sectionId?: string;
}> = ({ title, buttonProps, sectionId = SELECT_PLAN_SECTION_ID }) => {
  const {
    isLoadingPlans,
    monthlyPlan,
    selectedPlan,
    stripePlans,
    checkIsPlanActive,
    billingPortalLink,
  } = useStripeV2Plans();

  const { show } = useAppModals('paywall');

  if (isLoadingPlans) {
    return <SelectPlanStyles id={sectionId}>Loading...</SelectPlanStyles>;
  }

  const reversedUserPlans = stripePlans.slice().reverse();

  return (
    <SelectPlanStyles id={sectionId}>
      {title && <>{title}</>}
      <SelectPlanListStyles className={'inverted'}>
        {reversedUserPlans.map((subscription) => (
          <SimpleSubscriptionButton
            selected={checkIsPlanActive(subscription.id)}
            subscription={subscription}
            key={subscription.id}
          />
        ))}
      </SelectPlanListStyles>
      <SubscriptionButtonStyles
        type="button"
        onClick={() => {
          if (buttonProps?.onClick) {
            buttonProps.onClick();
          } else {
            show({ stripePlans, billingPortalLink });
          }
        }}
      >
        {buttonProps?.text || 'GET PREMIUM'}
      </SubscriptionButtonStyles>

      <SimplePaymentDescription
        selectedPlan={selectedPlan}
        monthlyPlan={monthlyPlan}
      />
    </SelectPlanStyles>
  );
};
